import { ConfigMurucaResourceLayout } from '@net7/boilerplate-muruca';

export default {
  maxHeight: 100, // Threshold where the "read-more" button appears
  title: 'Opera',
  type: 'record',
  tabs: 'record',
  sections: {
    top: [
      {
        id: 'header',
        type: 'title',
        grid: null,
      },
      {
        id: 'editor_metadata',
        type: 'metadata',
      },
      {
        id: 'tab-bar',
        type: 'tabs',
        options: {
          tabsContents: [
            'metadata-bib-title', 'metadata-bib-parte', 'metadata-bib-notas',
            'metadata-bib-manuscrito', 'metadata-bib-otra', 'metadata-bib-colecciones',
            'metadata-bib-ediciones', 'metadata-bib-refundiciones', 'metadata-bib-biblio',
            'metadata-fec-fecha', 'metadata-fec-computo',
            'metadata-per-computables', 'metadata-per-no-computables', 'metadata-per-universo',
            'metadata-per-ambientacion', 'metadata-per-espaciosI', 'metadata-per-espaciosII',
            'metadata-per-espaciosIII', 'metadata-per-duracion',
            'metadata-gen-adscripcion', 'metadata-gen-adscripcion-secundaria',
            'metadata-gen-notas', 'metadata-gen-sinopsis', 'metadata-gen-autor',
          ]
        }
      }
    ],
    content: [
      {
        id: 'button',
        type: 'button',
        options: {
          text: 'Descargar PDF',
          link: 'pdf-download',
          iconRight: 'n7-icon-download'
        }
      },
      {
        id: 'metadata-per-computables',
        type: 'metadata',
        title: '',
      },
      {
        id: 'metadata-per-no-computables',
        type: 'metadata',
        title: '',
      },
      {
        id: 'metadata-per-universo',
        type: 'metadata',
        title: '',
      },
      {
        id: 'metadata-per-ambientacion',
        type: 'metadata',
        title: '',
      },
      {
        id: 'metadata-per-espaciosI',
        type: 'metadata',
        title: '',
      },
      {
        id: 'metadata-per-espaciosII',
        type: 'metadata',
        title: '',
      },
      {
        id: 'metadata-per-espaciosIII',
        type: 'metadata',
        title: '',
      },
      {
        id: 'metadata-per-duracion',
        type: 'metadata',
        title: '',
      },
      // {
      //   id: 'text-viewer',
      //   type: 'text-viewer',
      //   options: {
      //     searchId: 'xml_text',
      //   },
      // },
      // {
      //   id: 'collection-witnesses',
      //   type: 'collection',
      //   grid: 3,
      //   title: 'Testimoni collegati',
      // },
      // {
      //   id: 'collection-taxonomies',
      //   type: 'collection',
      //   grid: 3,
      //   title: 'Tassonomie collegate',
      // },
    ],
  },
} as ConfigMurucaResourceLayout;
